import { Link } from "react-router-dom";
import { Waves } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/30 mt-24" role="contentinfo" aria-label="Site footer" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary/20 border border-primary/30 flex items-center justify-center">
                <Waves className="w-4 h-4 text-primary" />
              </div>
              <span className="text-lg font-semibold" style={{ fontFamily: "'Playfair Display', serif" }}>ToneHealing</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              Professional binaural beats, Solfeggio frequencies, and ambient soundscapes for 50+ health conditions. Free, science-backed sound therapy.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: "/", label: "Home" },
                { to: "/blog", label: "Blog" },
                { to: "/therapy/anxiety", label: "Anxiety" },
                { to: "/therapy/sleep", label: "Sleep" },
                { to: "/therapy/focus", label: "Focus" },
                { to: "/therapy/pain", label: "Pain Relief" },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-primary transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground">Legal</h4>
            <ul className="space-y-2">
              {[
                { to: "/privacy", label: "Privacy Policy" },
                { to: "/terms", label: "Terms of Service" },
                { to: "/disclaimer", label: "Medical Disclaimer" },
                { to: "/accessibility", label: "Accessibility" },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-primary transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
            <p className="text-xs text-muted-foreground/60 mt-4">Contact: support@lifeownit.com</p>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-10 pt-8 border-t border-border/20 text-center">
          <p className="text-xs font-semibold tracking-widest text-muted-foreground/50 uppercase mb-3">ToneHealing Featured In</p>
          <img src={`${process.env.PUBLIC_URL}/trust-badges.png`} alt="ToneHealing featured in FOX, Google News, and Digital Journal" className="mx-auto h-8 sm:h-10 object-contain opacity-60" />
        </div>

        {/* Disclaimer bar */}
        <div className="mt-12 pt-8 border-t border-border/20">
          <p className="text-xs text-muted-foreground/60 leading-relaxed mb-3">
            <strong>Affiliate Disclosure:</strong> This site contains affiliate links and displays advertisements. We may earn a commission from purchases made through these links at no additional cost to you. This helps support our free platform. <a href="/disclaimer" className="text-primary hover:underline">See our full disclosure</a>.
          </p>
          <p className="text-xs text-muted-foreground/50 leading-relaxed">
            <strong>Medical Disclaimer:</strong> This platform is for wellness and relaxation purposes only. Not intended to diagnose, treat, cure, or prevent any medical condition. 
            Not a substitute for professional medical advice. Do not use while driving or operating machinery. 
            Users assume full responsibility for safe usage. <a href="/disclaimer" className="text-primary hover:underline">Read full disclaimer</a>.
          </p>
          <p className="text-xs text-muted-foreground/40 mt-4">&copy; {new Date().getFullYear()} ToneHealing.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
